import { createFileRoute } from '@tanstack/react-router';
import { ConfiguracoesPage, lerBuscaConfiguracoes } from '@/components/configuracoes-rateio';

export const Route = createFileRoute('/_app/custos/configuracoes-rateio')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaConfiguracoes(bruto),
  component: ConfiguracoesRota,
});

function ConfiguracoesRota() {
  return <ConfiguracoesPage busca={Route.useSearch()} />;
}
